import { Button } from "@mantine/core";
import { type ReactNode } from "react";

interface IAddRowButton {
  onClick?: () => void;
  children: ReactNode;
  icon: ReactNode;
  color?: string;
  disabled?: boolean;
  loading?: boolean;
  mt?: number;
}

const RowActionButton = ({
  onClick,
  children,
  icon,
  color,
  disabled,
  loading,
  mt,
}: IAddRowButton) => {
  return (
    <Button
      onClick={onClick}
      variant="outline"
      size="sm"
      mt={mt ?? 15}
      mr={5}
      ml={5}
      color={color}
      disabled={disabled}
      loading={loading}
      leftIcon={icon}>
      {children}
    </Button>
  );
};

export default RowActionButton;
